var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleHalfRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3a13 13 0 1013 13A13.013 13.013 0 0016 3zm1 2.046a10.8 10.8 0 012 .375v21.163a10.79 10.79 0 01-2 .375V5.046zm4 1.158c.713.365 1.383.806 2 1.317V24.48c-.617.51-1.287.952-2 1.317V6.204zM5 16A11.014 11.014 0 0115 5.046v21.908A11.014 11.014 0 015 16zm20 6.317V9.682a10.978 10.978 0 010 12.635z"
  })));
}
export default SvgCircleHalfRegular;